import { useTranslation } from '@dukanti/shared';
import type { TranslationKey } from '@dukanti/shared';
import { SkeletonBar } from '@/features/products/components/skeleton-bar';

export function PromotionalAdsListSkeleton() {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      aria-busy="true"
      data-testid="promotional-ads-list-skeleton"
      className="border-border bg-card shadow-admin-card rounded-lg border p-4"
    >
      <span className="sr-only">{t('admin.promotionalAds.title' as TranslationKey)}</span>
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="border-border flex flex-col gap-3 border-b py-4 last:border-b-0 sm:flex-row sm:items-center"
        >
          <SkeletonBar className="aspect-[3/1] w-full rounded-lg sm:w-48" />
          <div className="min-w-0 flex-1">
            <SkeletonBar className="mb-2 h-5 w-44" />
            <SkeletonBar className="mb-2 h-4 w-28" />
            <SkeletonBar className="h-4 w-56 max-w-full" />
          </div>
          <SkeletonBar className="h-9 w-32 rounded-md" />
        </div>
      ))}
    </div>
  );
}
